<template>
  <ul class="nav-link-list" :class="{ [`nav-link-list--${context}`]: context }">
    <li v-for="(link, index) in links" :key="index" class="nav-link-list__list">
      <a
        class="nav-link-list__link"
        :class="{ 'nav-link-list__link--active': link.active }"
        :href="link.href"
        :target="link.target"
        rel="noopener"
      >
        <dotcom-icon
          v-if="link.iconName && ['both', 'icon'].includes(viewType)"
          :name="link.iconName"
          class="nav-link-list__icon"
        />
        <span v-if="['both', 'label'].includes(viewType)">
          {{ formattedTitle(link) }}
        </span>
      </a>
    </li>
  </ul>
</template>

<script>
import DotcomIcon from '@/modules/icon/Icon'

export default {
  name: 'NavLinkList',
  components: {
    DotcomIcon,
  },
  props: {
    links: {
      type: Array,
      required: true,
    },
    viewType: {
      type: String,
      default: 'both',
      validator(value) {
        return ['icon', 'label', 'both'].includes(value)
      },
    },
    upperCase: Boolean,
    context: {
      type: String,
      default: null,
      validator(value) {
        return ['meta', 'special'].includes(value)
      },
    },
    special: Boolean,
  },
  methods: {
    formattedTitle(link) {
      return this.upperCase ? link.title.toUpperCase() : link.title
    },
  },
}
</script>

<style lang="postcss" scoped>
.nav-link-list {
  display: inline-flex;
  gap: var(--spacing-4) var(--spacing-6);
  list-style-type: none;
  flex-wrap: wrap;
}

.nav-link-list--special,
.nav-link-list--meta {
  flex-wrap: nowrap;

  .nav-link-list__link {
    color: var(--c-primary-neutral-1);
  }
}

.nav-link-list--special {
  flex-direction: column;

  .nav-link-list__link {
    color: var(--c-primary-neutral-1);
  }

  .nav-link-list__icon {
    width: var(--spacing-6);
  }
}

.nav-link-list__link {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  color: var(--c-secondary-neutral-1);
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  height: 20px;

  &:hover {
    color: var(--c-primary-color-2);
    border-bottom: 0;
  }
}

.nav-link-list__link.nav-link-list__link--active {
  color: var(--c-primary-color-2);
  font-weight: 600;
}

@media (--lg) {
  .nav-link-list {
    flex: 0 0 auto;
    flex-wrap: nowrap;
    align-items: center;
    gap: var(--spacing-4) var(--spacing-6);
  }

  .nav-link-list__link {
    color: var(--c-primary-neutral-1);
    font-size: 12px;
    line-height: 20px;
    font-weight: 600;
  }

  .nav-link-list__icon {
    font-size: 16px;
  }
}
</style>
